import React, { PropsWithChildren, useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import { colors } from 'theme/colors';
import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';
import LoginBackground from 'assets/images/login-background.png';
import { IImageData, useLogoSetup } from 'pages/SystemSettingsPage/LogoSetupPage/hooks';
import { ELoginPartTypes } from 'models/loginScreenSetup';
import Logo from 'components/atoms/Logo';
import LogoImage from 'assets/images/logo-white.svg';
import { Loader } from 'components/atoms/Loader';

const StyledBackgroundSection = styled(Grid)`
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${LoginBackground});
  background-position: center;
`;
const StyledBackgroundSectionSubtitle = styled.p`
  margin-top: 20px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: ${colors.white};
`;

export const StyledAuthHeader = styled(Typography)`
  color: ${colors.primary500};
  font-weight: 600;
  font-size: 2rem;
  text-align: center;
  line-height: 32px;
`;

const AuthTemplate = ({ children }: PropsWithChildren) => {
  const [isLoadingLoginScreen, setLoadingLoginScreen] = useState<boolean>(true);
  const { getLoginScreen, loginScreenDataParsed } = useLogoSetup();

  useEffect(() => {
    setLoadingLoginScreen(true);
    (async () => {
      await getLoginScreen().then(() => {
        setLoadingLoginScreen(false);
      });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container sx={{ minHeight: '100vh', justifyContent: 'center', display: 'flex' }}>
      {children}
      <StyledBackgroundSection
        size={{ lg: 6 }}
        sx={{
          display: { xs: 'none', xl: 'flex' },
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: 10,
        }}
      >
        <Box>
          <Logo src={LogoImage} alt="Logo" />
        </Box>
        <Box>
          {loginScreenDataParsed?.[ELoginPartTypes.HEADER] && (
            <Typography
              variant="h3"
              sx={{ fontWeight: 700, textAlign: 'center', color: colors.white }}
            >
              {loginScreenDataParsed[ELoginPartTypes.HEADER] as string}
            </Typography>
          )}
          {(!loginScreenDataParsed?.[ELoginPartTypes.HEADER] ||
            !loginScreenDataParsed?.[ELoginPartTypes.SUBHEADER]) &&
            isLoadingLoginScreen && (
              <Box sx={{ justifyContent: 'center' }}>
                <Loader isLoading={isLoadingLoginScreen} color={colors.white} />
              </Box>
            )}
          {loginScreenDataParsed?.[ELoginPartTypes.SUBHEADER] && (
            <StyledBackgroundSectionSubtitle>
              {loginScreenDataParsed[ELoginPartTypes.SUBHEADER] as string}
            </StyledBackgroundSectionSubtitle>
          )}
        </Box>
      </StyledBackgroundSection>
    </Grid>
  );
};

export { AuthTemplate };
